module.exports = __webpack_public_path__ + "static/lifafa-67d25f0d67751eba2e00bdd38e4091c7.jpg";